export default __webpack_public_path__ + "static/media/tab2_1.35fa92a5.png";